import { Globe, ArrowUpRight, Check } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal, SectionLabel, Stagger, Item } from "../components/Reveal";
import { WhatsAppButton } from "../components/CTA";
import { useContent, visibleWork } from "../data/siteContent";

export default function Work() {
  const content = useContent();
  const projects = visibleWork(content);

  return (
    <div data-testid="work-page">
      <SEO title="Our Work | Allcov" description="Exactly what we've built — allcov.com, Quikpik, Divy Power flipbook, and labelled concept redesigns." path="/work" />
      <PageHero
        eyebrow="Our Work"
        title="Our work"
        line="We're a young company, so here is exactly what we've built — nothing borrowed, nothing invented."
        testid="work"
      />

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Stagger className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {projects.map((p) => (
              <Item key={p.id || p.name} className="h-full">
                <div className="flex h-full flex-col border border-line bg-surface p-7" data-testid={`work-item-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  {p.image ? (
                    <img src={p.image} alt={p.name} className="h-9 w-auto object-contain" loading="lazy" />
                  ) : (
                    <Globe size={26} className="text-pop" strokeWidth={1.5} />
                  )}
                  <p className="mt-6 font-batangas text-xl tracking-tight">
                    {p.link ? (
                      <a href={p.link} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-pop">
                        {p.name}
                        <ArrowUpRight size={14} className="text-faint transition-colors duration-300 group-hover:text-pop" />
                      </a>
                    ) : (
                      p.name
                    )}
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-mut">{p.summary}</p>
                  {p.bullets?.length > 0 && (
                    <ul className="mt-3 flex-1 space-y-2">
                      {p.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-2.5 text-sm text-mut">
                          <Check size={14} className="mt-0.5 shrink-0 text-pop" />
                          {b}
                        </li>
                      ))}
                    </ul>
                  )}
                  {!p.bullets?.length && <span className="flex-1" />}
                  <p className="mt-5 text-[10px] uppercase tracking-[0.2em] text-faint">{p.label}</p>
                </div>
              </Item>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="border-t border-line py-20 lg:py-24" data-testid="work-closing">
        <div className="mx-auto max-w-4xl px-6 text-center lg:px-10">
          <Reveal>
            <h2 className="font-batangas text-3xl leading-tight tracking-tight md:text-4xl">
              Your business could be our next case study.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 text-sm text-mut">Founding clients get our best price.</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-9 flex justify-center">
              <WhatsAppButton testid="work-whatsapp" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
